__turbopack_context__.v({
  "cardsContainer": "s4Mkoa_cardsContainer",
  "ctaCard": "s4Mkoa_ctaCard",
  "getQuoteLabel": "s4Mkoa_getQuoteLabel",
});
